import PropTypes from 'prop-types';
import React from 'react';
import { Button, Table, Modal, ButtonToolbar } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import moment from 'moment';
import MemberDetailModal from './MemberDetailModal';
import ManageBidEditMamber from './ManageBidEditMamber';
import { getCurrentDate } from '../../../core/date';

class ManageEditBid extends React.Component {
  constructor(props) {
      super(props);
      const members =[];
      const memberValue = this.props.tour.members;
      let bidDetails = this.props.bidbidsDetails;
      const bidId = this.props.bid.id;
      let group = null;
      bidDetails.map(val => {
        if(bidId == val.bid){
          let travelId = val.bid_details.travelprofile_id;
          let bidVal = val.bid_details;
          memberValue.map(profile => {
            if(profile.id==travelId){
              let data ={
                id:profile.id,
                first_name:profile.first_name,
                last_name:profile.last_name,
                check_in_date:bidVal.check_in_date,
                check_out_date:bidVal.check_out_date,
                email:profile.email,
                title:profile.title,
                phone_number:profile.phone_number,
                group:profile.group,
                Suite:bidVal.suite,
                King:bidVal.king,
                Double:bidVal.double,
                room_type:bidVal.room_type,
                tour_id:bidVal.tour_id,
                group_id:bidVal.group_id,
                event_id:bidVal.event_id,
                bidId:val.bid,
                bidDetail : bidVal.id,
              }
              if(data.room_type !==4){
                members.push(data);
              }
              group = profile.group
            }
          })
        }
      })
      const groupsData = [];
      groupsData.push(group)
      const EditCell={
        mode: 'click',
          blurToSave: true,
          beforeSaveCell: this.BeforeSaveCell,
          afterSaveCell: this.AfterSaveCell,
      }

      this.state = {
        members,
        date:false,
        room:false,
        EditCell,
        showWarning:false,
        modalText:'',
        checkInDate:this.props.bid.bidset.event.start,
        checkOutDate:this.props.bid.bidset.event.end,
        roomTypeData:null,
        editMemberPopUp:false,
        memberEdit:null,
        tourId : this.props.tour.id,
        bidId : this.props.bid.id,
        group:groupsData,
        showConfirm : false,
        rowData:null,
        showChangeDate:false,
        addMember:false,
        datePayload:null,
      };
      this.changeDate = this.changeDate.bind(this);
      this.changeRoomType = this.changeRoomType.bind(this);
      this.handleAddMember = this.handleAddMember.bind(this);
      this.closeChangeDate = this.closeChangeDate.bind(this);
      this.closeChangeRoomType = this.closeChangeRoomType.bind(this);
      this.closeEditMeber = this.closeEditMeber.bind(this);
      this.getRow = this.getRow.bind(this);
      this.deleteMember = this.deleteMember.bind(this);
      this.cancelRow = this.cancelRow.bind(this);
      this.HideComfimationBox = this.HideComfimationBox.bind(this);
      this.HideDateComfimationBox = this.HideDateComfimationBox.bind(this);
      this.showChangeDatePopUp = this.showChangeDatePopUp.bind(this);
      this.closeChangeDatePopUp = this.closeChangeDatePopUp.bind(this);
      this.changeBidData = this.changeBidData.bind(this);
      this.addParticipant = this.addParticipant.bind(this);
      this.saveChangeDate = this.saveChangeDate.bind(this);
      this.changeMemberData = this.changeMemberData.bind(this);

  }
  changeDate(){
    this.setState({ date: true });
  }

  closeChangeDate(){
    this.setState({ date: false });
  }

  changeRoomType(){
    this.setState({ room: true });
  }
  closeChangeRoomType(){
    this.setState({ room: false });
  }
  handleAddMember(){
    this.setState({
      editMemberPopUp:true,
      addMember:true,
    })
  }
  closeEditMeber(){
    this.setState({
      editMemberPopUp :false,
      memberEdit:null,
    })
  }
  getRow(cell, row){
    let memberVal = {};
    this.state.members.forEach((member) =>{
      if(member.id==cell){
        memberVal.id = member.id
        memberVal.first_name = member.first_name
        memberVal.last_name = member.last_name
        memberVal.title = member.title
        memberVal.phone_number = member.phone_number
        memberVal.group = member.group_id
        memberVal.email = member.email
      }
    })
    this.setState({
      editMemberPopUp :true,
      addMember:false,
      memberEdit:memberVal,
    })
  }
  cancelRow(cell, row){
    this.setState({
      showConfirm:true,
      rowData:row,
    })
  }
  HideComfimationBox(){
    this.setState({
      showConfirm:false,
      rowData:null,
    })
  }
  HideDateComfimationBox(){
    this.setState({showConfirmDate:false})
  }
  saveChangeDate(){
    const payload = this.state.datePayload;
    this.props.ChangeBidDetail(payload, (response) => {
          let members = this.state.members;
          this.setState({
            showConfirmDate:false,
            members,
          })
    });
  }
  addParticipant(data){
    const checkIn = this.props.bid.bidset.event.start;
    const checkOut = this.props.bid.bidset.event.end;
    const event = this.props.bid.bidset.event.id;

    const payload = {'check_in_date':checkIn,'check_out_date':checkOut,'event_id':event,
      'suite':false,'king':false,'double':false,'first_name':data.first_name,
      'last_name':data.last_name, 'title':data.title,'group':data.group.id,'email':data.email,
      'phone_number':data.phone_number,'tour_id':data.tour_id,'bid':this.state.bidId}

    this.props.addParticipantManageBid(payload, (response) => {
      this.props.changeData(response);
      this.changeMemberData(response);
    });
  }
  changeMemberData(response){
    const members =[];
      const memberValue = response.tour.members;
      let bidDetails = response.BidBidDetails;
      const bidId = this.props.bid.id;
      let group = null;
      bidDetails.map(val => {
        if(bidId == val.bid){
          let travelId = val.bid_details.travelprofile_id;
          let bidVal = val.bid_details;
          memberValue.map(profile => {
            if(profile.id==travelId){
              let data ={
                id:profile.id,
                first_name:profile.first_name,
                last_name:profile.last_name,
                check_in_date:bidVal.check_in_date,
                check_out_date:bidVal.check_out_date,
                email:profile.email,
                title:profile.title,
                phone_number:profile.phone_number,
                group:profile.group,
                Suite:bidVal.suite,
                King:bidVal.king,
                Double:bidVal.double,
                room_type:bidVal.room_type,
                tour_id:bidVal.tour_id,
                group_id:bidVal.group_id,
                event_id:bidVal.event_id,
                bidId:val.bid,
                bidDetail : bidVal.id,
              }
              if(data.room_type !==4){
                members.push(data);
              }
              group = profile.group
            }
          })
        }
      })
      this.setState({members:members})
  }
  deleteMember(){
    const id = this.state.rowData.id;
    const group_id = this.state.rowData.group_id;
    const memberDataNew = [];
    let payload = {'id':id,'group_id':group_id,'roomType':null};
    let membersData = this.state.members;
    membersData.forEach((member) =>{
      if(member.id == id){
        if(member.Suite){
          payload.roomType='Suite';
        }
        if(member.King){
          payload.roomType='King';
        }
        if(member.Double){
          payload.roomType='Double';
        }
        
      }else{
          memberDataNew.push(member);
      }
    })
    this.props.deleteTourMember(payload);
    this.setState({
      showConfirm:false,
      rowData:null,
      members:memberDataNew,
    })
  }
  showChangeDatePopUp(){
    this.setState({showChangeDate:true})
  }
  closeChangeDatePopUp(){
    this.setState({
      showChangeDate:false,
      date: false,
    })
  }
  changeBidData(){
    this.setState({
      showChangeDate:false,
      date: false,
    })

  }
  handlDateChange = (e)=>{
    let name = e.target.name;
    if(name=='checkInDate'){
      this.setState({
        checkInDate:e.target.value
      })
    } else{
      this.setState({
        checkOutDate:e.target.value
      })
    }
  }

  applyDateChange = () =>{
    this.setState({ date: false });
    if (this.state.checkInDate>this.state.checkOutDate){
      this.setState({ 
        showWarning: true, 
        modalText: "Please enter a valid check-in/out date. check-in date should be earlier than the check-out date." 
      });
        return false;
    }else if(this.state.checkOutDate == '' || this.state.checkInDate == '') {
      this.setState({ 
        showWarning: true, 
        modalText: "Check-in/out date should not be blank." 
      });
        return false;
    }
    let members = this.state.members;
    let start = document.getElementById('checkInDate');
      let end = document.getElementById('checkOutDate');

      let payload = []; 
      let type = "";
      let event_id = this.props.bid.bidset.event.id;

      this.state.members.forEach((member)=>{
        type = member.Suite ? 1 : member.King ? 2 : member.Double ? member.Double ? 3 : 0 : 0
        if(type > 0){
          payload.push({ suite: member.Suite,
           king: member.King, double: member.Double,
            check_in_date: start.value, check_out_date: end.value,
             travelprofile_id: member.id, 
             tour_id: member.tour_id, group_id: member.group_id,
             bid_id: member.bidId, event_id: member.event_id,
             id: member.bidDetail, room_type: type })
        }
      })
      if(payload.length > 0) {
        this.props.changeBidDateDetail(payload,1, (response)=>{
          payload = {
            start:start.value,
            end:end.value,
          }
          let startDate = moment(start.value);
          let endDate = moment(end.value);

          let memberData = this.state.members
          memberData.forEach((member) =>{
            member.check_in_date = startDate
            member.check_out_date = endDate
          })
          this.setState({
            checkInDate:startDate,
            checkOutDate:endDate,
            members:memberData,
          })
          this.props.requestBidDetails(this.props.bid.id)
          this.props.editGroupEventOnManageBid(event_id,payload)
          //location.reload(false);
        });
      }
  }

  CloseWarning =() =>{
    this.setState({ showWarning: false });
  }

  BeforeSaveCell = (row, cellName, cellValue) => {
    if (cellName == 'check_in_date' || cellName == 'check_out_date') {
      let checkIn;
      let checkOut;
      if (cellName == 'check_in_date') {
        checkIn = new Date(cellValue);
        checkOut = new Date(row.check_out_date);
      } else if(cellName == 'check_out_date'){
        checkIn = new Date(row.check_in_date);
        checkOut = new Date(cellValue);
      }
      if (checkIn > checkOut) {
        this.setState({ 
          showWarning: true, 
          modalText: "Check-in date should be before the check-out date", 
        });
        return false;
      }
    }
  }
  AfterSaveCell = (row, cellName, cellValue) => {
    if (cellName == 'check_in_date' || cellName == 'check_out_date') {
      const Seleted = row.Suite || row.King || row.Double;
      let type = 0
      if (Seleted) {
        if (row.Suite){type = 1;}
        if (row.King){type = 2;}
        if (row.Double){type = 3;}
        const payload = { suite: row.Suite, king: row.King, double: row.Double, 
          check_in_date: row.check_in_date, check_out_date: row.check_out_date, 
          travelprofile_id: row.id, tour_id: row.tour_id, group_id: row.group_id, 
          bid_id: row.bidId, event_id: row.event_id, id: row.bidDetail, room_type: type 
        };

        this.setState({
          datePayload:payload,
          showConfirmDate:true,
        });
      }
    }
  }

  checkboxSuiteFormatter = (cell, row) => {
    const id = `suite_${row.id}`
    return (
      <input type='checkbox' id={id} checked={row.Suite} onChange={(e) => this.changeCheckBox(e, row, 1)} />
    )
  }
  checkboxkingFormatter = (cell, row) => {
    const id = `king_${row.id}`
    return (
      <input type='checkbox' id={id} checked={row.King} onChange={(e) => this.changeCheckBox(e, row, 2)} />
    )
  }
  checkboxdoubleFormatter = (cell, row) => {
    const id = `double_${row.id}`
    return (
      <input type='checkbox' id={id} checked={row.Double} onChange={(e) => this.changeCheckBox(e, row, 3)} />
    )
  }
  changeCheckBox = (e, row, type) => {
    document.querySelector(`#suite_${row.id}`).disabled = true;
    document.querySelector(`#king_${row.id}`).disabled = true;
    document.querySelector(`#double_${row.id}`).disabled = true;

    const members = [...this.state.members];
    const member = members.find(a => a.id == row.id);
    let checkBox = e.target.checked;

    let selectedRoom = '';
    let unselectedRoom = [];
    switch (type) {
      case 1:
        selectedRoom = "Suite"
        unselectedRoom.push("King")
        unselectedRoom.push("Double")
        break;
      case 2:
        selectedRoom = "King"
        unselectedRoom.push("Suite")
        unselectedRoom.push("Double")
        break;
      case 3:
        selectedRoom = "Double"
        unselectedRoom.push("King")
        unselectedRoom.push("Suite")
        break;
    }
    member[selectedRoom] = checkBox ? 1 : 0;
    member[unselectedRoom[0]] = 0;
    member[unselectedRoom[1]] = 0
    const payload = { suite: member.Suite, king: member.King, double: member.Double, 
      check_in_date: member.check_in_date, check_out_date: member.check_out_date, 
      travelprofile_id: member.id, tour_id: member.tour_id, group_id:member.group_id, 
      bid_id:member.bidId , event_id:member.event_id , id:member.bidDetail, room_type:type};
    this.props.ChangeBidDetail(payload,(response) => {
      member.bidDetail=response.id;
      document.querySelector(`#suite_${row.id}`).disabled = false;
        document.querySelector(`#king_${row.id}`).disabled = false;
        document.querySelector(`#double_${row.id}`).disabled = false;
      this.setState({
        members,
      })
    })
  }
  checkboxsuiteFormatterRoomType = (cell, row,enumObject) => {
    let nameAttr = row.group_id + '_roomTypeoptions';
    return (
      <input type='radio' name={nameAttr} id={row.group_id} onChange={(e) => this.updateRoomType(e, row, 1)} />
    )
  }

  checkboxkingFormatterRoomType = (cell, row,enumObject) => {
    let nameAttr = row.group_id + '_roomTypeoptions';
    return (
      <input type='radio' name={nameAttr} id={row.group_id} onChange={(e) => this.updateRoomType(e, row, 2)} />
    )
  }
  
  checkboxdoubleFormatterRoomType = (cell, row,enumObject) => {
    let nameAttr = row.group_id + '_roomTypeoptions';
    return (
      <input type='radio' name={nameAttr} id={row.group_id} onChange={(e) => this.updateRoomType(e, row, 3)} />
    )
  }
  updateRoomType = (e, row,type,enumObject) =>{
    let roomTypeData = {};
    let selectedRoom = '';
    let unselectedRoom = [];

    switch (type) {
      case 1:
        selectedRoom = "Suite"
        unselectedRoom.push("King")
        unselectedRoom.push("Double")
        unselectedRoom.push("NoHotel")
        break;
      case 2:
        selectedRoom = "King"
        unselectedRoom.push("Suite")
        unselectedRoom.push("Double")
        unselectedRoom.push("NoHotel")
        break;
      case 3:
        selectedRoom = "Double"
        unselectedRoom.push("King")
        unselectedRoom.push("Suite")
        unselectedRoom.push("NoHotel")
        break;
      case 4:
        selectedRoom = "NoHotel"
        unselectedRoom.push("Suite")
        unselectedRoom.push("King")
        unselectedRoom.push("Suite")
        break;
    }

    row[selectedRoom] = 1;
    row[unselectedRoom[0]] = 0;
    row[unselectedRoom[1]] = 0;
    
    roomTypeData['Suite'] = row.Suite;
    roomTypeData['King'] = row.King
    roomTypeData['Double'] = row.Double
    roomTypeData['NoHotel'] = row.NoHotel
    roomTypeData['room_type'] = type

    this.setState({
      roomTypeData: roomTypeData
    })

  }
  handleRoomType= () => {
    this.setState({
    isApplyDisabled: true
    })
    this.closeChangeRoomType();
    let payload =[]; 
    let roomTypes = this.state.roomTypeData;
    let updateMembers = this.state.members;

    this.state.members.forEach((data) =>{
      let checkIn = getCurrentDate(data.check_in_date)
      let checkOut = getCurrentDate(data.check_out_date)

      payload.push({ suite: roomTypes.Suite, king: roomTypes.King, double: roomTypes.Double,
       check_in_date: checkIn, check_out_date: checkOut, 
       travelprofile_id: data.id, tour_id: data.tour_id, group_id: data.group_id, bid_id: data.bidId,
       event_id: data.event_id, id: data.bidDetail, room_type: roomTypes.room_type })
    })

    this.props.changeBidDateDetail(payload, 1, (response)=>{
      updateMembers.forEach((bid)=>{
        bid.Suite = roomTypes.Suite ? true : false
        bid.King = roomTypes.King ? true : false
        bid.Double = roomTypes.Double ? true : false
        bid.NoHotel = !roomTypes.Suite && !roomTypes.King && !roomTypes.Double ? true : false
      })
      roomTypes.Suite = 0;
      roomTypes.King = 0;
      roomTypes.Double = 0;

      this.setState({
        members: updateMembers,
        roomTypeData: roomTypes,
        isApplyDisabled: false
      })
    })
  }

  render() {
    const addMember = this.state.addMember;
    const memberEdit = this.state.memberEdit;

    const groupData = [];
    groupData.push({
      group:this.props.bid.bidset.event.group_name,
      group_id:this.props.bid.tourgroup_id

    })
    const options = {
          sortIndicator: false ,
          defaultSortName: 'start',
          paginationShowsTotal: this.renderShowsTotal,
          paginationPosition: 'top',
          sizePerPage:25,
          hideSizePerPage: true
      };
      const trStyle = (row, rowIndex) => {
          return { backgroundColor: typeof(row) != 'undefined' ? row.bgcolor : ''};
      };
      const buttonFormatter = (cell, row) => <div>
          <Button onClick={() => this.getRow(cell, row)} ><i className="fa fa-pencil fa-lg" style={{ bordercolor: '#5bc0e8 !important' }} /></Button>&nbsp;&nbsp;&nbsp;&nbsp;
          <Button onClick={() => this.cancelRow(cell, row)} ><i className="fa fa-remove" style={{ bordercolor: '#5bc0e8' }} /></Button>
      </div>;

    return(
      <div>
      <Modal bsSize="large" show={this.props.showPopUp} onHide={()=>this.props.OnClose()}>
              <Modal.Header closeButton>
                  <Modal.Title>Edit Bid</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <h4> Change - Check In/Out date & Room type</h4>
                  <center><br/>
                    <Button bsStyle="success" onClick={this.changeDate}>Set Check In/Out Date</Button>&nbsp;&nbsp;
                    <Button bsStyle="success" onClick={this.changeRoomType}>Default Room Types</Button>&nbsp;&nbsp;
                    <Button bsStyle="success" onClick={this.handleAddMember}><i className="fa fa-user-plus" /> Add Member</Button><br/>
                    <BootstrapTable
                      data={this.state.members}
                      trStyle = { trStyle }
                        options = { options }
                        striped
                        pagination
                        cellEdit={this.state.EditCell}
                    >
                      <TableHeaderColumn dataField="first_name" width="90" headerAlign="center" dataAlign="center" editable={{ type: 'text' }} >First Name</TableHeaderColumn>
                        <TableHeaderColumn dataField="last_name" width="90" headerAlign="center" dataAlign="center" editable={{ type: 'text' }}>Last Name</TableHeaderColumn>
                        <TableHeaderColumn dataField="check_in_date" width="100" headerAlign="center" dataAlign="center" editable={{ type: 'date' }}>Check-In Date</TableHeaderColumn>
                        <TableHeaderColumn dataField="check_out_date" width="100" headerAlign="center" dataAlign="center" editable={{ type: 'date' }}>Check-Out Date</TableHeaderColumn>
                        <TableHeaderColumn dataField="Suite" width="70" headerAlign="center" dataAlign="center" dataFormat={this.checkboxSuiteFormatter} editable={false}>Suite</TableHeaderColumn>
                        <TableHeaderColumn dataField="King" width="70" headerAlign="center" dataAlign="center" dataFormat={this.checkboxkingFormatter} editable={false}>King</TableHeaderColumn>
                        <TableHeaderColumn dataField="Double" width="70" headerAlign="center" dataAlign="center" dataFormat={this.checkboxdoubleFormatter} editable={false}>Double</TableHeaderColumn>
                        <TableHeaderColumn dataField="id" width="85" isKey headerAlign="center" dataAlign="center" dataFormat={buttonFormatter} editable={false}>Action</TableHeaderColumn>
                    </BootstrapTable><br/>

                  </center>
      
                  {this.state.showWarning && (
                    <Modal show={this.state.showWarning} onHide={this.CloseWarning}>
                  <Modal.Header closeButton>
                  <Modal.Title>Error</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                  <p> {this.state.modalText}</p>
                  <ButtonToolbar style={{ float: 'right' }}>
                      <Button
                        bsStyle="success"
                      onClick={this.CloseWarning}
                      >Ok</Button>
                  </ButtonToolbar><br/>
                  </Modal.Body>
              </Modal>
                )}

                {this.state.date && (
                  <Modal show={this.state.date} onHide={this.closeChangeDate}>
                      <Modal.Header closeButton>
                        <Modal.Title>Set Check In/Out Dates</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        Check In Date: 
                        <input type="date" id="checkInDate" name="checkInDate" className="form-control" value={this.state.checkInDate} onChange={this.handlDateChange} max={ "9999-12-31" } required/><br /><br />
                        Check Out Date:
                        <input type="date" id="checkOutDate" name="checkOutDate" className="form-control" value={this.state.checkOutDate} onChange={this.handlDateChange} max={ "9999-12-31" } required/><br /><br />
                        <ButtonToolbar style={{ float: 'right' }}>
                          <Button
                            bsStyle="success"
                            onClick={this.applyDateChange}
                          >Apply</Button>
                          <Button
                            bsStyle="danger"
                            onClick={this.closeChangeDate}
                          >Cancel</Button>
                        </ButtonToolbar><br/><hr/>
                        <ButtonToolbar>
                          <Button
                            bsStyle="success"
                            onClick={this.showChangeDatePopUp}
                          >Change Date to Limited Members</Button>
                        </ButtonToolbar><br/>
                        <span> Change Check-In/Out date to Limited Group members.</span>
                      </Modal.Body>
                      <Modal.Footer style={{ clear: 'both' }} />
                  </Modal>
                )}
                {this.state.room && (
                 <Modal show={this.state.room} onHide={this.closeChangeRoomType}>
                  <Modal.Header closeButton>
                  <Modal.Title>Change Room Type</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <div id="setRoomTypeModalSection">
                        <BootstrapTable
                          data={groupData}
                         striped
                        >
                          <TableHeaderColumn dataField="group" width="80" headerAlign="center" dataAlign="center" editable={false} >Group</TableHeaderColumn>
                          <TableHeaderColumn dataField="Suite" width="50" headerAlign="center" dataAlign="center" dataFormat={this.checkboxsuiteFormatterRoomType} editable={false}>Suite</TableHeaderColumn>
                          <TableHeaderColumn dataField="King" width="50" headerAlign="center" dataAlign="center" dataFormat={this.checkboxkingFormatterRoomType} editable={false}>King</TableHeaderColumn>
                          <TableHeaderColumn dataField="Double" width="50" headerAlign="center" dataAlign="center" dataFormat={this.checkboxdoubleFormatterRoomType} editable={false}>Double</TableHeaderColumn>
                          <TableHeaderColumn dataField="group_id" isKey width="1" headerAlign="center" dataAlign="center" hidden>Group ID</TableHeaderColumn>
                        </BootstrapTable>
                    </div>
                    <ButtonToolbar style={{ float: 'right' }}>
                       <Button
                         bsStyle="success"
                         onClick={this.handleRoomType}
                        >Apply</Button>
                        <Button
                         bsStyle="success"
                         onClick={this.closeChangeRoomType}
                        >Cancel</Button>
                    </ButtonToolbar><br/>
                  </Modal.Body>
                 </Modal>
                  )}
                  {this.state.showChangeDate &&(
                    <ManageBidEditMamber
                    closeChangeDatePopUp={this.closeChangeDatePopUp}
                    showChangeDate={this.state.showChangeDate}
                    members={this.state.members}
                    event={this.props.bid.bidset.event}
                    tourId={this.state.tourId}
                    changeDateRoomType={this.props.changeDateRoomType}
                    changeBidData={this.changeBidData}
                    updateBidData={this.props.updateBidData}
                    />

                  )}
                  {this.state.editMemberPopUp && (
                    <MemberDetailModal
                      tourId={this.state.tourId}
                      member={addMember?({}):memberEdit}
                      show={this.state.editMemberPopUp}
                      onClose={this.closeEditMeber}
                      addMember={this.addParticipant}
                      editMember={this.props.editMember}
                      groups={this.state.group}

                      dispatchRemoveMemberFromGroup={this.props.dispatchRemoveMemberFromManageBid}
                      isParticipantGrid={true}

                    />
                  )}
                </Modal.Body>
            </Modal>
            {this.state.showConfirm && (
              <Modal show={this.state.showConfirm} onHide={this.HideComfimationBox}>
                <Modal.Header closeButton>
                  <Modal.Title>Delete Member</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <p>Are you sure want to delete member ?</p>
                  <ButtonToolbar style={{ float: 'right' }}>
                    <Button
                      bsStyle="success"
                      onClick={this.deleteMember}
                    >Confirm</Button>
                    <Button
                      bsStyle="success"
                      onClick={this.HideComfimationBox}
                    >Cancel</Button>
                  </ButtonToolbar><br/><br/>
                </Modal.Body>
              </Modal> 
            )}
            {this.state.showConfirmDate && (
              <Modal show={this.state.showConfirmDate} onHide={this.HideDateComfimationBox}>
                <Modal.Header closeButton>
                  <Modal.Title>Date Change</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <p>Are you sure want to change date ?</p>
                  <ButtonToolbar style={{ float: 'right' }}>
                    <Button
                      bsStyle="success"
                      onClick={this.saveChangeDate}
                    >Confirm</Button>
                    <Button
                      bsStyle="success"
                      onClick={this.HideDateComfimationBox}
                    >Cancel</Button>
                  </ButtonToolbar><br/><br/>
                </Modal.Body>
              </Modal> 
            )}
    </div>
    );
  }
}

export default ManageEditBid;


// WEBPACK FOOTER //
// src/routes/tours/components/ManageEditBid.js